'use strict';
/*
    Creates a link that scrolls to another element on the same page
    i.e. <internal-link target="#abc">ABC</internal-link>

    Tabs created by `tabset` directive are activated automatically.
*/
namespace TR {

    class InternalLink {

        target: string;
        offset: string; // Adjust final scroll pos upwards

        constructor (
            private scrollService,
            private $timeout
        ) {

        }

        navigate (): void {
            let targetEl = $(this.target),
                tabSet = targetEl.closest('.tab-set'),
                contentSelector = '.tab-content';

            if (tabSet.length) {
                let tabContent = targetEl.find(contentSelector) ||
                        targetEl.closest(contentSelector);

                // Select tab then scroll
                if (tabContent) {
                    this.$timeout(() => {
                        // Shows tab with no anim
                        tabContent.triggerHandler('dblclick');
                        this.scrollToTarget();
                    });
                }
            } else {
                this.scrollToTarget();
            }
        }

        scrollToTarget (): void {
            const $target = $(this.target);
            if ($target.length) {

                /// Here we are taking the tab-bar height, and adding it to the offset of the scroll. This way, scroll
                /// will stop when it comes to the top of the tabs and they will remain visible. If our target is lower
                /// in the tab panel, the height of the tabs will not be taken into consideration.
                /// 'TargetAndTabDiff' is the difference between the top of the tabs, and top of the target, and if this
                /// difference is larger than tab height (plus some additional delta), we do not consider tab height.

                const targetTop = $target.offset().top;
                const $tabSet = $target.closest('.tab-set');
                const tabOffset = _.reduce($tabSet.toArray(), (memo:number, el:any) => {
                    const $tabBar = $(el).find('.tab-bar:first');
                    if ($tabBar.length) {
                        const diffDelta = 50;
                        const tabTop = $tabBar.offset().top;
                        const tabHeight = $tabBar.outerHeight();
                        const targetAndTabDiff = Math.abs(targetTop - tabTop);
                        return 'none' !== $tabBar.css('display') && targetAndTabDiff <= tabHeight + diffDelta
                            ? memo + tabHeight : memo;
                    } else {
                        return memo;
                    }
                }, 1);

                /// Get all sticky elements in the page and reduce them to the value of the height of the tallest one,
                /// which comes before our scroll target in the dom tree. We are calculating the offset, which is equal
                /// to the height of tallest sticky element. This is because the sticky elements do not stack, so we
                /// have to stop with the scrolling 'stickyElementHeight' pixels before reaching our target, otherwise
                /// our sticky element would cover the target element.

                const $stickyElements = $('.sticky-wrapper');
                const stickyOffset = _.reduce($stickyElements.toArray(), (memo:number, el:any) => {
                    const $el = $(el);
                    const elTopOffset = $el.offset().top;
                    const elHeight = $el.outerHeight();

                    /// We are also taking into consideration if the sticky element has a bottom limit before our
                    /// target. Sticky element bottom limit is a point at which the sticky element is not scrolled with
                    /// the page anymore. Sticky elements with the bottom limits before our target are not taken into
                    /// customer when calculating the offset.

                    let isStickyLimitBeforeTarget = false;
                    const bottomAutoId = $el.data('bottomLimitId');
                    if (bottomAutoId) {
                        const $stickyLimit = $(`[data-id="${bottomAutoId}"]`);
                        if ($stickyLimit.length) {
                            const stickyLimitBottom = $stickyLimit.offset().top + $stickyLimit.outerHeight();
                            isStickyLimitBeforeTarget = stickyLimitBottom < targetTop;
                        }
                    }

                    return elTopOffset < targetTop && elHeight > memo && !isStickyLimitBeforeTarget ? elHeight : memo;
                }, 0);

                /// On mobile we need to take into customer also the fixed header.
                const $header = $('.header-main');
                let headerOffset = 0;
                if ('fixed' === $header.css('position')) {
                    headerOffset = $header.outerHeight();
                }

                const navBar = $('.header-wrapper');
                const navBarOffset = navBar ? navBar.outerHeight() : 0;

                this.scrollService.scrollTo(this.target, {
                    animate: true,
                    offset: (parseInt(this.offset, 10) || 0) + stickyOffset + tabOffset + headerOffset + navBarOffset
                });
            }
        }
    }

    angular
        .module('TR')
        .directive('internalLink', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                transclude: true,
                replace: true,
                controller: InternalLink,
                controllerAs: 'il',
                bindToController: {
                    target: '@',
                    offset: '@'
                },
                template: `<a ng-click="il.navigate()" ng-transclude></a>`
            };
        });
}
